import { COURIER,COURIER_SERVICE_TYPE } from 'domains/customer-refund-shipment/constants'
import * as Yup from 'yup'


/** Schema for create Customer Refund Shipment */
const customerRefundShipmentCreateSchema = Yup.object().shape({
  courier: Yup.string().oneOf(
    Object.values(COURIER),
    `Must be one of this value: ${Object.values(COURIER).join(', ')}`
  ).required('Required'),
  courier_service_type: Yup.string().oneOf(
    Object.values(COURIER_SERVICE_TYPE),
    `Must be one of this value: ${Object.values(COURIER_SERVICE_TYPE).join(', ')}`
  ).required('Required')
})

export default customerRefundShipmentCreateSchema
